import { httpClient } from '#shared'
import { type SetUnreadCountResponse } from '../models/set-unread-count-response'

export async function setUnreadCount(chatId: number, count: number) {
  const response = await httpClient.patch<SetUnreadCountResponse>('chats/' + chatId, {
    json: {
      unreadCount: count,
    },
    requireAuth: true,
  })

  const responseBody = await response.json()

  return responseBody
}
